const ACTIVE_CLASS = "media-gallery__cylindo-control--active";

class CylindoTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.closest("button");

    if (!this.button) return;

    this.button.addEventListener("click", (e) => {
      const action = this.button.classList.contains(ACTIVE_CLASS)
        ? null
        : this.action;

      e.target.dispatchEvent(
        new CustomEvent("cylindo-trigger", {
          bubbles: true,
          detail: { action },
        }),
      );
    });

    this.handleTrigger = (e) => {
      const { action } = e.detail;

      const isActive = action === this.action;

      this.button.classList.toggle(ACTIVE_CLASS, isActive);
    };

    document.addEventListener("cylindo-trigger", this.handleTrigger);
  }

  disconnectedCallback() {
    document.removeEventListener("cylindo-trigger", this.handleTrigger);
  }

  get action() {
    return this.getAttribute("action");
  }
}

if (!customElements.get("cylindo-trigger")) {
  customElements.define("cylindo-trigger", CylindoTrigger);
}
